<template >
	<div style="overflow: hidden;">
		<el-card shadow="hover" >
			<el-form :model="school" label-width="120px" size="mini">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="学校名称">
							<el-input v-model="school.schoolName" disabled />
						</el-form-item>
						<el-form-item label="学校简称">
							<el-input v-model="school.shortName" @input="modifyText" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系人">
							<el-input v-model="school.contact" disabled />
						</el-form-item>
						<el-form-item label="联系电话">
							<el-input v-model="school.phone" disabled />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属省份">
							<el-input v-model="school.provinceName" disabled />
						</el-form-item>
						<el-form-item label="所属城市">
							<el-input v-model="school.cityName" disabled />
						</el-form-item>
						<el-form-item label="所属区县">
							<el-input v-model="school.areaName" disabled />
						</el-form-item>
						<el-form-item label="详细地址">
							<el-input v-model="school.address" @input="modifyText" />
						</el-form-item>
					</el-col>
				</el-row>
		
				<el-form-item label="学校状态">
					<el-tag :type="school.status === 0 ? 'success' : 'danger'">
						{{ school.status === 0 ? '正常' : '禁用' }}
					</el-tag>
				</el-form-item>
		
				<el-form-item label="学校Logo">
					<div class="logo-upload-area">
						<!-- 优先展示本地临时图片，没有则展示后端logo -->
						<div 
						  v-if="tempLocalPreview || (school.logo && !removeLogoFlag)" 
						  class="logo-preview"
						  @click="triggerFileInput"
						>
						  <img :src="tempLocalPreview || school.logo" alt="logo" />
						  <div class="mask">
						    <span>点击更换图片</span>
						  </div>
						</div>
						<div v-else class="upload-btn" @click="triggerFileInput">
							<i class="el-icon-plus"></i>
							<p>点击上传Logo</p>
						</div>
						<input ref="fileInput" type="file" accept="image/*" style="display: none" @change="onFileSelect" />
					</div>
					<div style="margin-top:8px">
						<el-button v-if="tempLocalPreview || (school.logo && !removeLogoFlag)" size="mini" type="text"
							@click="handleRemoveLogo">移除Logo</el-button>
					</div>
				</el-form-item>
		
				<el-form-item>
					<el-button type="primary" v-if="!isModify" style="background-color: #666666;"
						:disabled="!isModify">更新信息</el-button>
					<el-button type="primary" @click="updataLogin" v-else>更新信息</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'SchoolInfo',
		data() {
			return {
				school: {},
				schoolId: localStorage.getItem('orgId'),
				userId: localStorage.getItem('userId'),
				roleType: localStorage.getItem('roleType'),
				login: null,
				file: null, // 选中的图片文件（等待上传）
				form: {}, // 原始数据备份
				isModify: false,
				removeLogoFlag: false, // 是否需要清空数据库logo
				tempLocalPreview: '' // 纯本地预览地址，不上传OSS
			}
		},
		created() {
			this.getSchoolInfo()
		},
		methods: {
			// 判断是否有修改
			modifyText() {
				const origin = this.form
				const curr = this.school
				console.log("地址",origin.address !== curr.address)
				console.log("简称",origin.shortName !== curr.shortName)
				console.log("logo",!this.file&&curr.logo==""&&origin.logo!="")
				if (origin.address !== curr.address || origin.shortName !== curr.shortName || (!this.file&&curr.logo==""&&origin.logo!="")||this.file) {
					this.isModify = true
				} else {
					this.isModify = false
				}
			},

			// 移除logo
			handleRemoveLogo() {
				// 释放本地预览资源，防止内存泄漏
				if (this.tempLocalPreview) {
					URL.revokeObjectURL(this.tempLocalPreview)
				}
				if(!this.file){
					this.school.logo=""
				}
				this.file = null
				this.tempLocalPreview = ''
				this.removeLogoFlag = true
				console.log('this.file', this.file)
				this.modifyText()
			},

			triggerFileInput() {
				this.$refs.fileInput.click()
			},

			// 选中图片：只生成本地预览！不执行上传！
			onFileSelect(e) {
				const files = e.target.files
				if (!files || files.length === 0) {
					return
				}
				if(!this.file){
					this.school.logo=""
				}
				// 释放旧预览url
				if (this.tempLocalPreview) {
					URL.revokeObjectURL(this.tempLocalPreview)
				}
				this.file = files[0]
				// 本地预览渲染
				this.tempLocalPreview = URL.createObjectURL(this.file)
				this.removeLogoFlag = false
				this.modifyText()
			},

			// 获取学校信息
			async getSchoolInfo() {
				this.loginOpen('学校信息加载中...')
				try {
					let res =await this.API.get(this.API.school.getSchoolId + this.schoolId)
					this.school = {}
					this.form={}
					console.log('res',res.data.data)
					if(res?.data?.data){
						this.school=res.data.data
						this.form={...res.data.data}
					}
					console.log('初始：',this.form)
					if (this.tempLocalPreview) {
						URL.revokeObjectURL(this.tempLocalPreview)
					}
					this.tempLocalPreview = ''
					if (res?.data?.data?.logo) {
						this.tempLocalPreview = await this.$oss.getDownloadUrl(res.data.data.logo)
						this.school.url=this.tempLocalPreview
					}
					this.file = null
					this.removeLogoFlag = false
					this.isModify = false
				}catch(err){
					
				}finally{
					this.noLogin()
				}

			},

			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
				}
			},

			// 点击【更新】才执行上传oss + 保存接口
			async updataLogin() {
				console.log('this.file',this.file)
				// return
				this.loginOpen('login上传中...')
				let logoUrl = null
				try {
					// 如果选择了图片，此时才上传OSS
					if (this.file) {
						let ossData = await this.getOrgIdLogin()
						logoUrl = await this.uploadToOss(this.file, ossData)
					}
					// 请求后端更新
					await this.putSchoolUpdateLogin(logoUrl)
					// 刷新页面数据
					this.getSchoolInfo()
					this.$message.success('保存成功')
				} catch (err) {
					console.error(err)
					this.$message.error('保存失败')
				} finally {
					this.noLogin()
				}
			},

			async putSchoolUpdateLogin(logoUrl) {
				let pames = {
					schoolId: this.schoolId,
					address: this.school.address,
					shortName: this.school.shortName
				}
				// 场景1：上传新图片
				if (this.file && logoUrl) {
					pames.logo = logoUrl
				}
				// 场景2：移除logo，传null清空数据库
				if(!this.file&&this.form.logo!=this.school.logo){
					pames.logo =''
				}
				
				if(logoUrl){
					localStorage.setItem('orgLogo',logoUrl)
					this.$bus.$emit('refresh-org-logo')
				}
				if(this.form.logo!=this.school.logo&&!logoUrl){
					
					localStorage.setItem('orgLogo',"AI智能体互动课堂校平台")
					this.$bus.$emit('refresh-org-logo')
				}
				// 场景3：图片无操作，不携带logo字段，保留原值
				await this.API.put(this.API.admin.putSchoolUpdateLogin, pames)
			},

			async getOrgIdLogin() {
				try {
					let res = await this.API.get(this.API.fileurl.getOrgIdLogin, {
						type: 'login',
						orgId: localStorage.getItem("orgId"),
						userType: localStorage.getItem("userType"),
						userId: this.userId,
					})
					return res.data
				} catch (err) {
					return null
				}
			},

			async uploadToOss(file, ossData) {
				console.log('1file', file)
				if (!file || !ossData) throw new Error('file / ossData 不能为空')
				if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

				const host = ossData.host.replace(/\/$/, '')
				const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
				const ext = file.name.split('.').pop().toLowerCase() || 'png'
				const key = `${dir}${ossData.uuid}.${ext}`

				const formData = new FormData()
				formData.append('key', key)
				formData.append('OSSAccessKeyId', ossData.accessKeyId)
				formData.append('signature', ossData.signature)
				formData.append('policy', ossData.policy)
				formData.append('file', file)
				try {
					const controller = new AbortController()
					const timer = setTimeout(() => controller.abort(), 30000)
					const res = await fetch(host, {
						method: 'POST',
						body: formData,
						signal: controller.signal
					})
					clearTimeout(timer)
					if (res.status === 200 || res.status === 204) {
						return key
					}
					const errMsg = await res.text()
					console.error('❌ OSS 报错：', res.status, errMsg)
					throw new Error(`上传失败 ${res.status}`)
				} catch (err) {
					console.error('❌ 上传异常：', err)
					const msg = err.name === 'AbortError' ? '上传超时' : err.message
					throw new Error('上传失败：' + msg)
				}
			}
		}
	}
</script>

<style scoped>
	.logo-upload-area {
		width: auto;
		max-width: 500px;
		height: 100px;
	}

	.upload-btn {
		width: 100%;
		height: 100%;
		border: 1px dashed #dcdfe6;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #8c8c8c;
		cursor: pointer;
	}

	.upload-btn i {
		font-size: 32px;
	}

	.logo-preview {
		width: 100%;
		height: 100%;
		position: relative;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
	}

	.logo-preview img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.logo-preview .mask {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 40px;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
	}
</style>